import { defineOverridesPreferences } from '@vben/preferences';

/**
 * @description 项目配置文件
 * 只需要覆盖项目中的一部分配置，不需要的配置不用覆盖，会自动使用默认配置
 * !!! 更改配置后请清空缓存，否则可能不生效
 */
export const overridesPreferences = defineOverridesPreferences({
  // overrides
  app: {
    /**
     * 不要动这里  后端路由模式
     */
    accessMode: 'backend',
    /**
     * 认证页面布局：panel-right 表单在右侧
     */
    authPageLayout: 'panel-right',
    /**
     * 不需要refresh token 由后端处理
     */
    enableRefreshToken: false,
    /**
     * 隐藏偏好设置图标
     */
    enablePreferences: false,
    /**
     * 这里可以设置默认头像 url链接或vite导入的图片链接
     */
    // defaultAvatar: '',
    name: import.meta.env.VITE_APP_TITLE,
    /**
     * 不支持modal模式 需要改动的地方太多
     * 1. 正常重新登录后不会再触发接口请求 即触发登录超时的页面为空数据
     * 2. 切换租户登录后不会重新加载菜单
     */
    // loginExpiredMode: 'modal',
    layout: 'mixed-nav',

    watermark: true,
  },
  header: {
    mode: "auto-scroll"
  },
  copyright: {
    companyName: '楚秀人力资源 鄂ICP备2021008710号',
    companySiteLink: 'https://beian.miit.gov.cn',
    date: '2025',
  },
  footer: {
    /**
     * 不显示footer
     */
    enable: true,
  },
  sidebar: {
    autoActivateChild: true,
    fixedButton: false,
    width: 190,
  },
  tabbar: {
    /**
     * 标签tab 持久化 关闭
     */
    persist: true,
    // styleType: 'card',
  },
  theme: {
    semiDarkHeader: true,
    /**
     * 浅色sidebar
     */
    semiDarkSidebar: false,
    /**
     * 圆角大小 换算比例为1.6px = 0.1radius
     * 这里为6px 与antd保持一致
     */
    radius: '0.375',
    builtinType: 'default',
    colorPrimary: 'hsl(231 98% 65%)',
  },
  widget: {
    lockScreen: true,
  },
  /**
   * !!! 更改配置后请清空浏览器缓存
   * 在这里更换logo
   * source可选值：
   * 1. 本地public目录下的图片 需要加上/ 比如：/logo.png
   * 2. 网络图片链接
   * 3. vite导入的图片 import xxx from 'xxx.png'
   *
   * !!! 更改配置后请清空浏览器缓存
   */
  // logo: {
  //   enable: true,
  //   source: '',
  // },
});
